import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=0d479faa"
import script from "./RoleEdit.vue?vue&type=script&lang=ts"
export * from "./RoleEdit.vue?vue&type=script&lang=ts"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=0d479faa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports